<template>
    <div class="page">

        <el-select v-model="value"
                   class="item-select"
                   placeholder="请选择"
                   value="">
            <el-option
                    v-for="item in dataInfo"
                    :key="item.leaseID"
                    :label="item.orgName + '-' + item.aptName"
                    :value="JSON.stringify(item)">
            </el-option>
        </el-select>

        <div class="list-none" v-if="isShowNone">未查询到该房间的杂费信息</div>

        <main v-else>
            <div class="item-3" v-if="isShowCharge">
                <div>
                    <div class="item-name">
                        <strong>电费余额</strong>
                        <div>（预付{{limitCharge}}元起）</div>
                    </div>
                    <strong class="item-value">￥{{valueCharge}}</strong>
                    <div class="item-op item-op3" @click="gotoCharge(infoCharge)">立即充值</div>
                </div>
            </div>

            <div class="item-2" v-if="isShowCool">
                <div>
                    <div class="item-name">
                        <strong>水费余额</strong>
                        <div>（预付{{limitCoolWater}}元起）</div>
                    </div>
                    <strong class="item-value">￥{{valueCoolWater}}</strong>
                    <div class="item-op item-op2" @click="gotoCharge(infoCool)">立即充值</div>
                </div>
            </div>

            <div class="item-1" v-for="item in extDataInfo" :key="item.id">
                <div>
                    <div class="item-name">
                        <strong>{{item.name}}余额</strong>
                        <div>（预付{{item.price}}元起）</div>
                    </div>
                    <strong class="item-value">￥{{item.balance}}</strong>
                    <div class="item-op item-op1" @click="gotoCharge(item)">立即充值</div>
                </div>
            </div>
        </main>
         <div class="list-none" v-if="dataInfo.length==0">
            <img src="../../../assets/list-none.png" alt="" />
            <div>空荡荡的~暂无数据！</div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {Message} from 'element-ui';
    import {MessageBox} from 'element-ui';
    import randomWord from "../../RandomWord"
    import wx from "weixin-js-sdk";

    export default {
        name: "Select",

        data() {
            return {
                value: '',

                isShowNone: false,

                isShowCharge: false,
                limitCharge: "",
                valueCharge: "",
                infoCharge: "",

                isShowCool: false,
                infoCool: "",
                limitCoolWater: "",
                valueCoolWater: "",

                dataInfo: [],
                extDataInfo: []
            }
        },

        watch: {
            value() {
                this.getInfo();
            }
        },

        methods: {

            getInfo() {
                this.isShowCharge = false;
                this.isShowCool = false;

                let info = JSON.parse(this.value);

                this.isShowNone = false;
                this.extDataInfo = []

                if (info && info.fees && info.fees.length > 0) {
                    info.fees.forEach(item => {
                        if (item.name === "电费") {
                            this.isShowCharge = true;
                            this.valueCharge = parseInt(item.balance / 100);
                            this.limitCharge = parseInt(item.price / 100);
                            this.infoCharge = item;
                        }
                        else if (item.name === "水费") {
                            this.isShowCool = true;
                            this.valueCoolWater = parseInt(item.balance / 100);
                            this.limitCoolWater = parseInt(item.price / 100);
                            this.infoCool = item;
                        }
                        else {
                            let data = {};
                            data.name = item.name
                            data.balance = parseInt(item.balance / 100);
                            data.price = parseInt(item.price / 100);
                            data.id = randomWord.randomWord(false, 16);
                            this.extDataInfo.push(data);
                        }
                    });
                }
                else {
                    this.isShowNone = true;
                }
            },

            gotoCharge(item) {
                if (this.value === "") {
                    return;
                }
                let info = JSON.parse(this.value);

                // 微信小程序
                wx.miniProgram.getEnv(function() {
                    if (item.isPostPay) {

                        wx.miniProgram.navigateTo({
                            url: "/pages/sundry/topup?"
                                + "leaseID=" + info.leaseID
                                + "&aptID=" + info.aptID
                                + "&aptName=" + encodeURI(info.aptName)
                                + "&orgID=" + info.orgID
                                + "&orgName=" + encodeURI(info.orgName)

                                + "&name=" + encodeURI(item.name)
                                + "&price=" + item.price
                                + "&unit=" + encodeURI(item.unit)
                                + "&balance=" + item.balance
                                + "&isPostPay=" + item.isPostPay
                        });
                    }
                    else {
                        MessageBox.confirm('该费用为预付费，请与房租一起支付', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            wx.miniProgram.navigateTo({
                                url: "/pages/bill/unpaid"
                            });
                        }).catch(() => {});
                    }

                });
            }
        },


        created() {
            document.title = "杂费管理";
            let url = axios.defaults.baseURL.replace('v1/org/','')
            axios({
                method: 'post',
                url: url+"v1/users/sundries/query",
                headers: {
                    'Authorization': this.$route.query.token,
                    'PYDDot-Client-Type':this.$route.query.client,
                    'X-Ca-Timestamp':parseInt(new Date().getTime()/1000)
                },
                data: {}
            }).then(value => {
                if (value.data.data) {
                    this.dataInfo = value.data.data;

                    if (this.dataInfo && this.dataInfo.length > 0) {
                        this.value = JSON.stringify(this.dataInfo[0]);
                    }
                }
                if (value.data.code !== 0) {
                    Message.error(value.data.message);
                }
            }).catch((err) => {
                Message.error(err.toString());
            });
        }
    }
</script>

<style scoped lang="scss">
    @import "../pay/page";

    .page {
        padding-top: 20px;

        .item-select {
            z-index: 111;
            width: 90%;
            margin-left: 5%;
        }

        .item-1, .item-2, .item-3 {
            background: #4DC495;
            color: $bgColor;
            align-items: center;
            flex-direction: row-reverse;
            display: flex;
            height: 160px;
            width: 90%;
            margin: 10px auto;
            >div {
                box-sizing: border-box;
                padding: 10px;
                align-items: center;
                flex-direction: column;
                display: flex;
                height: 100%;
                justify-content: space-around;
                .item-name {
                    display: flex;
                    align-items: center;
                    div {
                        font-size: 13px;
                    }
                }
                .item-value {
                    font-size: 30px;
                }
                .item-op {
                    text-align: center;
                    font-size: 14px;
                    box-sizing: border-box;
                    background: white;
                    width: 90px;
                    line-height:32px;
                    background:rgba(255,255,255,1);
                    box-shadow:0 6px 18px 0 rgba(19, 67, 78, 0.35);
                    opacity:0.5;
                    border-radius:32px;
                }
                .item-op1 {
                    color: #747FCD;
                }
                .item-op2 {
                    color: #DE3F4E;
                }
                .item-op3 {
                    color: #5586C4;
                }
            }
        }

        .item-1 {
            background: url("../../../assets/charge/img-1.png") no-repeat;
            background-size: 100%;
        }
        .item-2 {
            background: url("../../../assets/charge/img-2.png") no-repeat;
            background-size: 100%;
        }
        .item-3 {
            background: url("../../../assets/charge/img-3.png") no-repeat;
            background-size: 100%;
        }
    }
</style>
